import { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import { resolveHoverPreviewBoardWidth } from './hoverPreviewBoardSizes';

const readViewportHeight = () =>
  typeof window !== 'undefined' ? window.innerHeight : 900;

/** Responsive width for fixed-position hover preview popups. */
export const useHoverPreviewBoardWidth = (): number => {
  const theme = useTheme();
  const isUltraWide = useMediaQuery(theme.breakpoints.up('xxxl'));
  const isWideDesktop = useMediaQuery(theme.breakpoints.up('xxl'));
  const [viewportHeight, setViewportHeight] = useState(readViewportHeight);

  useEffect(() => {
    const onResize = () => setViewportHeight(window.innerHeight);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return resolveHoverPreviewBoardWidth({
    isUltraWide,
    isWideDesktop,
    viewportHeight,
  });
};
